import { MultiSelectDropdown } from '@cc-shopping/ui/composites/MultiSelectDropdown';
import { memo, useCallback } from 'react';
import { useFiltersAnalytics } from 'src/features/roundup-filters/store/hooks/useFiltersAnalytics';
import { useShallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../../../store/Context';
import { FilterType } from '../../../store/enums';
import type { OffersFilterStoreState } from '../../../store/types';
import type { FilterComponentProps } from './types';
import { createApplyAndNotify } from './utils';

export const IssuersFilter = memo(
  ({ options, forceClose, onAfterChange, labelledById }: FilterComponentProps) => {
    const { issuerFilter, handleSingleFormUpdate, handleApplyFilters } = useOffersFilterStore(
      useShallow((state: OffersFilterStoreState) => ({
        issuerFilter: state.filterFormState.issuerFilter,
        handleSingleFormUpdate: state.handleSingleFormUpdate,
        handleApplyFilters: state.handleApplyFilters,
      })),
    );

    const { fireIssuerUpdateEvents } = useFiltersAnalytics();

    const selectedLabels = issuerFilter.map(id => options.issuerIdToLabel[id]).filter(Boolean);

    const handleChange = useCallback(
      (labels: string[]) => {
        const ids = labels.map(label => options.issuerLabelToId[label]).filter(Boolean);
        createApplyAndNotify(
          handleSingleFormUpdate,
          handleApplyFilters,
          onAfterChange,
        )({ type: FilterType.ISSUER, value: ids });
        fireIssuerUpdateEvents({
          prevSelectedValues: issuerFilter,
          newSelectedValues: ids,
        });
      },
      [
        handleSingleFormUpdate,
        handleApplyFilters,
        options.issuerLabelToId,
        onAfterChange,
        fireIssuerUpdateEvents,
      ],
    );

    return (
      <MultiSelectDropdown
        label="Issuers"
        placeholder="All issuers"
        options={options.issuersOptions}
        selectedOptions={selectedLabels}
        onChange={handleChange}
        forceClose={forceClose}
        labelledById={labelledById}
      />
    );
  },
);
